"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft } from "lucide-react";
import type { Route } from "next";
import { useParams } from "next/navigation";
import { PageWrapper } from "@/components/page-wrapper";
import { CusteioDocumentDraft } from "@/components/projects/new/custeio-document-draft";
import { ProjectBasicForm } from "@/components/projects/new/project-basic-form";
import { ButtonLink } from "@/components/ui/button";
export default function NewProjectPage() {
  const $ = _c(11);
  const params = useParams();
  const organizationSlug = params.organizationSlug as string;
  const t0 = `/${organizationSlug}/projects` as Route;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArrowLeft />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t0) {
    t2 = <ButtonLink size="sm" variant="ghost" href={t0}>{t1}Voltar</ButtonLink>;
    $[1] = t0;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== organizationSlug) {
    t3 = <CusteioDocumentDraft organizationSlug={organizationSlug} />;
    $[3] = organizationSlug;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ProjectBasicForm />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="container mx-auto flex flex-col gap-8">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <PageWrapper back={t2} maxWidth="wizard" title="Novo projeto">{t5}</PageWrapper>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}